import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import VueShortKey from 'vue-shortkey';
import VueTheMask from 'vue-the-mask';
import VuePivottable from 'vue-pivottable';
import 'vue-pivottable/dist/vue-pivottable.css';
// import treeNodesDl from 'tree-nodes-dl';
import updateOnReload from '@/mixins/updateOnReload';
import 'normalize.css';
import format from 'date-fns/format';
import App from './App';
import registerVuetify from './vuetify';
import {
	httpRequestInterceptor,
	httpResponseInterceptor,
	httpResponseSuccessInterceptor,
} from './http/index';
import registerAxios from './axios';
import vueRouter from './router';
import globalMixin from './mixins/global';
import registerFilters from './filters/global';
import './global-components';
import store from './store';

Vue.use(VueShortKey);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(VuePivottable);
// Vue.use(treeNodesDl);
Vue.use(VueAnalytics, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true,
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'admin.quipu.com',
});

const userInfo = JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::adminUser`));
const router = vueRouter(Vue);
registerFilters(Vue);
registerVuetify(Vue);
registerAxios(Vue);
Vue.prototype.$today = format(new Date(), 'YYYY-MM-DD');
Vue.prototype.$bus = new Vue();
Vue.prototype.$imageUrl = process.env.S3_IMAGES_URL;
Vue.prototype.$userInfo = userInfo;
Vue.config.productionTip = false;
Vue.mixin(globalMixin);

async function created() {
	this.$bus.$on('USER_INFO', (user) => {
		Vue.prototype.$userInfo = user;
	});
	this.$http.interceptors.request.use(this.httpRequestInterceptor);
	this.$http.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpAcl.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpSales.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpSales.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpProducts.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpProducts.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpProduction.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpProduction.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
}

/* eslint-disable no-new */
new Vue({
	created,
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	mixins: [updateOnReload],
	router,
	render: h => h(App),
	store,
});



// WEBPACK FOOTER //
// ./src/main.js